import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`康格科技是一間專注於提供雲端服務開發及數位轉型服務的軟體及咨詢公司。我們擅於導入微服務架構解決方案及軟體持續交付與快速迭代的軟體開發模式。藉由業界多年的開發經驗及不斷創新的應用發展，幫您解決技術方面的難題，並結合各種情境持續打造符合客戶需求的軟體服務。`}</p>
    <h2>{`服務項目`}</h2>
    <ul>
      <li parentName="ul">{`應用開發服務 - 依客戶的創意或需求，提供應用規畫、設計、 開發、導入，並提供相關技術轉移，輔導客戶後續維運`}</li>
      <li parentName="ul">{`數位轉型服務 - 包含傳統轉型咨詢、規畫、應用變更、開發及導入`}</li>
      <li parentName="ul">{`系統遷移服務 - 遷移傳統應用系統、微服務架構規畫、應用變更、開發及導入`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      